((w) => {
    "use strict";

    const assetId = '~/theme/v1/Views/Document/ViewDocumentTemplatedContactForm.min.js';

    if (!((w).umwAssets?.[assetId])) {
        console.error(`No context found for ${assetId}`);
        return;
    }

    for (const ctx of (w).umwAssets[assetId]) {
        const feedbackControl = w.jQuery('.js-feedback-control'); // page builder css wrapper for uc129 Feedback control
        const buttonFeedbackControl = w.jQuery('#' + ctx.mainPanelId).find('.button-modal-form-btn');
        if (feedbackControl && buttonFeedbackControl) {
            buttonFeedbackControl.on('click', function () {
                w.jQuery.fancybox.open({
                    parentEl: "form:first",
                    src: feedbackControl,
                    type: 'inline'
                });
            });
        }
    }
})(window as any);